var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.69,
    height: 32.593,
    viewBox: "0 0 16.69 32.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.171,233.188a.732.732,0,0,0-.527.221l-15.21,15.57a.742.742,0,0,0-.21.53.722.722,0,0,0,.221.514l15.226,15.56a.741.741,0,0,0,1.04-.031.737.737,0,0,0-.018-1.035l-14.654-15.061L243.7,234.445a.743.743,0,0,0-.01-1.048A.732.732,0,0,0,243.171,233.188Z",
    transform: "translate(243.914 265.781) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontArrow);
export default __webpack_public_path__ + "static/media/front-arrow.7014f11cbcfdcad1debab0cfbd8050bb.svg";
export { ForwardRef as ReactComponent };